import { combineReducers } from 'redux';

import screen from './reducers/planTorresScreenReducer';
import gameDetails from './reducers/planTorresGameDetailsReducer';
import curriculum from './reducers/planTorresCurriculumReducer';
import standardRound from './reducers/planTorresStandardRoundReducer';
import standardStep from './reducers/planTorresStandardStepReducer';
import narration from './reducers/planTorresNarrationReducer';
import gameMode from './reducers/planTorresGameModeReducer';
import onboardingRound from './reducers/planTorresOnboardingRoundReducer';
import feedback from './reducers/planTorresFeedbackReducer';

const reducers = combineReducers({
  screen,
  gameDetails,
  curriculum,
  standardRound,
  standardStep,
  narration,
  gameMode,
  onboardingRound,
  feedback,
});

export default reducers;
